import { NationalIdentificationNumber, Passport } from '@dreryk/personal-external-identifier-common-api';

import { FieldControllerProps, Pesel } from '@dreryk/react-common';
import { StyledMaxWidth, TextInput } from '@dreryk/react-components';

import { personalDataTranslationKeys } from '../../../translations';

import { AuthorizedPersonIdentifierTypeVisitor } from './AuthorizedPersonIdentifierTypeField';

export type AuthorizedPersonIdentifierValue = string | null;

type AuthorizedPersonIdentifierValueFieldProps = FieldControllerProps<
   'authorizedPersonIdentifierValue',
   AuthorizedPersonIdentifierValue
> & {
   readonly authorizedPersonIdentifierTypeVisitor: AuthorizedPersonIdentifierTypeVisitor;
};

// eslint-disable-next-line max-lines-per-function
export const AuthorizedPersonIdentifierValueField = (
   props: AuthorizedPersonIdentifierValueFieldProps
): JSX.Element | null => {
   const { authorizedPersonIdentifierTypeVisitor } = props;

   return authorizedPersonIdentifierTypeVisitor({
      visitPesel: () => (
         <StyledMaxWidth maxWidth={263}>
            <TextInput
               testId={'authorizedPersonExternalIdentifierValue'}
               label={personalDataTranslationKeys.identifierValue.label}
               placeholder={personalDataTranslationKeys.identifierValue.placeholder.Pesel}
               controller={props.register('authorizedPersonIdentifierValue', {
                  required: true,
                  maxLength: Pesel.PESEL_LENGTH,
                  validate: (value) =>
                     Pesel.isValid(value as string)
                        ? undefined
                        : personalDataTranslationKeys.identifierValue.validate.invalidPesel,
               })}
               defaultValue={null}
            />
         </StyledMaxWidth>
      ),
      visitPassport: () => (
         <StyledMaxWidth maxWidth={263}>
            <TextInput
               testId={'authorizedPersonExternalIdentifierValue'}
               label={personalDataTranslationKeys.identifierValue.label}
               placeholder={personalDataTranslationKeys.identifierValue.placeholder.Passport}
               controller={props.register('authorizedPersonIdentifierValue', {
                  required: true,
                  maxLength: Passport.MAX_LENGTH,
                  pattern: {
                     value: new RegExp(Passport.PATTERN, 'u'),
                     message: personalDataTranslationKeys.identifierValue.validate.invalidPassportPattern,
                  },
                  validate: (value) =>
                     Passport.isValueValid(value as string)
                        ? undefined
                        : personalDataTranslationKeys.identifierValue.validate.invalidPassport,
               })}
               defaultValue={null}
            />
         </StyledMaxWidth>
      ),
      visitNationalIdentificationNumber: () => (
         <StyledMaxWidth maxWidth={263}>
            <TextInput
               testId={'authorizedPersonExternalIdentifierValue'}
               label={personalDataTranslationKeys.identifierValue.label}
               placeholder={personalDataTranslationKeys.identifierValue.placeholder.NationalIdentificationNumber}
               controller={props.register('authorizedPersonIdentifierValue', {
                  required: true,
                  maxLength: NationalIdentificationNumber.MAX_LENGTH,
                  pattern: {
                     value: new RegExp(NationalIdentificationNumber.PATTERN, 'u'),
                     message:
                        personalDataTranslationKeys.identifierValue.validate.invalidNationalIdentificationNumberPattern,
                  },
                  validate: (value) =>
                     NationalIdentificationNumber.isValueValid(value as string)
                        ? undefined
                        : personalDataTranslationKeys.identifierValue.validate.invalidNationalIdentificationNumber,
               })}
               defaultValue={null}
            />
         </StyledMaxWidth>
      ),
      visitBirthDate: () => null,
   });
};
